"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Option = _antd.Mentions.Option;
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Mentions, {
    style: {
      width: '100%'
    },
    status: 'error',
    disabled: true,
    defaultValue: "@afc163"
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "afc163"
  }, "afc163"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "zombieJ"
  }, "zombieJ"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "yesmeck"
  }, "yesmeck"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorBgContainerDisabled', 'colorTextDisabled'],
  key: 'disabled'
};
var _default = exports.default = componentDemo;